// Stored in users.avatar as `initials` (legacy: colour derived from the name)
// or `initials:#RRGGBB` (colour chosen by the user).
export const INITIALS_AVATAR = 'initials';

export const INITIALS_COLOR_PALETTE = [
  '#4C6EF5',
  '#F76707',
  '#2F9E44',
  '#E64980',
  '#7048E8',
  '#1098AD',
  '#F59F00',
  '#E03131',
  '#212529',
  '#868E96',
  '#0CA678',
  '#AE3EC9',
];

export const isInitialsAvatar = (avatar?: string | null): boolean =>
  avatar === INITIALS_AVATAR || !!avatar?.startsWith(`${INITIALS_AVATAR}:`);

export const makeInitialsAvatar = (color: string): string => `${INITIALS_AVATAR}:${color}`;

export const getInitials = (name?: string | null, surname?: string | null): string => {
  const first = name?.trim()?.[0] ?? '';
  const last = surname?.trim()?.[0] ?? '';
  const initials = `${first}${last}`.toUpperCase();
  return initials || '?';
};

export const getInitialsColor = (name?: string | null, surname?: string | null, avatar?: string | null): string => {
  const chosen = avatar?.startsWith(`${INITIALS_AVATAR}:`) ? avatar.slice(INITIALS_AVATAR.length + 1) : null;
  if (chosen && /^#[0-9A-Fa-f]{6}$/.test(chosen)) return chosen;

  const key = `${name ?? ''}${surname ?? ''}`;
  let hash = 0;
  for (let i = 0; i < key.length; i++) {
    hash = key.charCodeAt(i) + ((hash << 5) - hash);
  }
  // Only hash into the original 8 colours so legacy `initials` avatars keep the colour they already had
  return INITIALS_COLOR_PALETTE[Math.abs(hash) % 8];
};
